import React, { useEffect, useRef, useState } from "react";

import Header from "../../components/header";
import Navbar from "../../components/navbar";

import CardLeftRight from "../../components/cardleftright";

import { useLocation } from "react-router-dom";

import { DataLists } from "../../dataLists/DataLists";
import { dataListsType } from "../../components/featured-posts";
import AdPage from "../../components/AdPage";

const DetailsPage: React.FC = () => {
  // const { state } = useLocation();
  // const dataProps = state || {};

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let idItem = queryParams.get("id");

  const [currentItem, setCurrentItem] = useState<dataListsType | null>(null);

  const [recommended, setRecommended] = useState<dataListsType[]>([]);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const getRecommended = () => {
    const randomData = [...DataLists].sort(() => 0.5 - Math.random());
    const data = randomData.slice(0, 5);
    setRecommended(data);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getIdBodyHtml = () => {
    const datas = [...DataLists];
    if (!idItem) return null;
    const idBodyHtml = datas.find((item) => item.id.toString() === idItem);
    setCurrentItem(idBodyHtml || null);
  };

  useEffect(() => {
    getRecommended();
  }, []);
  useEffect(() => {
    getIdBodyHtml();
  }, [getIdBodyHtml, idItem]);

  useEffect(() => {
    const handleResize = (event: MessageEvent) => {
      if (event.data?.iframeHeight && iframeRef.current) {
        iframeRef.current.style.height = `${event.data.iframeHeight}px`;
      }
    };
    window.addEventListener("message", handleResize);
    return () => {
      window.removeEventListener("message", handleResize);
    };
  }, []);

  return (
    <>
      <Header />
      <Navbar />

      <AdPage />

      <div className="w-full flex justify-center">
        <iframe
          title="Details Page Content"
          className="w-full"
          style={{ height: "0px", transition: "height 0.2s" }}
          ref={iframeRef}
          srcDoc={`
            <!DOCTYPE html>
            <html lang="en">
              <head>
                <style>
                  body { overflow: hidden; margin: 0; }
                  *::-webkit-scrollbar { display: none; }
                   ${currentItem?.css ? currentItem.css : ""}
                  .loading {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100px;
                    width: 100%;
                    background-color: #f6f7f8;
                    color: #5e5e5e;
                    font-size: 1.5rem;
                    font-weight: bold;
                  }
                </style>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>Document</title>
              </head>
              <body>
                ${
                  currentItem?.body
                    ? currentItem.body
                    : `<div 
                        style="
                          font-size: 1.5rem; 
                          font-weight: bold; 
                          color: #5e5e5e; 
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 100px;
                          width: 100%;
                      ">Loading...</div>`
                }
                <script>
                  const resizeObserver = new ResizeObserver(() => {
                    const height = document.body.scrollHeight;
                    window.parent.postMessage({ iframeHeight: height }, '*');
                  });
                  resizeObserver.observe(document.body);
                  window.addEventListener('resize', () => {
                    const height = document.body.scrollHeight;
                    window.parent.postMessage({ iframeHeight: height }, '*');
                  });
                </script>
              </body>
            </html>
          `}
        ></iframe>
      </div>

      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center max-w-[888px] mt-5 mb-10">
          <div className="w-full mb-16 px-8">
            <div className="mb-8 border-b-[1px]">
              <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-widest flex justify-between">
                <span>Recommended</span>
              </h5>
              <span className="block w-14 h-[3px] bg-black"></span>
            </div>
            <div className="w-full flex flex-col gap-y-10">
              <CardLeftRight props={recommended} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsPage;
